module.exports = __webpack_public_path__ + "static/media/teamback1.14fac110.webp";